import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import styled from 'styled-components'
const ScrollToBottom = () => {
    return (
        <Wrapper><MdOutlineKeyboardArrowDown></MdOutlineKeyboardArrowDown></Wrapper>
    )
}

const Wrapper = styled.div`
        background-color:#9a86f3 ;
        color:white ;
        border-radius:50%;
        display:flex ;
        align-items:center ;
        justify-content:center ;
        font-size:1.5rem ;

`

export default ScrollToBottom